import * as types from "./mutation-type"
import api from "@/modules/api"

const actions = {
  async updateStoreMapping({ commit }, data) {
    try {
      commit(types.UPDATE_STORE_MAPPING_BEGIN)

      await Promise.all(Object.keys(data).map(storeId => api.companyStore.updateStore(storeId, { 
        linkedStoreId : data[storeId] || null
      })))
      
      commit(types.UPDATE_STORE_MAPPING_SUCCESS)
    } catch (e) {
      commit(types.UPDATE_STORE_MAPPING_ERROR, e)
    }
  }
}

export default actions;
